export default "__VITE_ASSET__$v$59tuO__"